import { MyModulesNoResults } from '@pickleballinc/ui/components/global/myModules/MyModulesNoResults';

import { PlayerTournamentCard } from '@/modules/players/v2/tabs/components/PlayerTournamentCard';
import { getNoResultsConfig } from '@/modules/players/v2/tabs/helpers';
import { PlayerData } from '@/types/players.types';
import { PlayerTournamentsData } from '@/types/playerTournaments.types';

interface PastTournametsProps {
  data: PlayerTournamentsData[];
  player?: PlayerData;
  isUserAlsoPlayer: boolean | undefined;
}

export function PastTournaments({ data, player, isUserAlsoPlayer }: PastTournametsProps) {
  const noResultsConfig = getNoResultsConfig({
    moduleType: 'tournament',
    isManage: false,
    isRegistered: true,
    player,
    isUserAlsoPlayer,
  });

  return data && data.length > 0 ? (
    <div className='mb-6 mt-0 sm:mt-4 grid grid-cols-1 min-[500px]:grid-cols-2 gap-4 py-0 sm:py-4 md:grid-cols-3 md:gap-6 lg:grid-cols-4'>
      {data.map((tourney) => {
        return (
          <PlayerTournamentCard
            key={`tournament-past-card-${tourney.tournamentUuid}`}
            tourney={tourney}
          />
        );
      })}
    </div>
  ) : (
    <div className='mx-auto max-w-[442px]'>
      <MyModulesNoResults {...noResultsConfig} />
    </div>
  );
}
